var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{attrs:{"okOnly":_vm.okOnly,"visible":_vm.showAlert}},[_vm._v(_vm._s(this.$t(_vm.alertMessage)))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }